const ADMIN_ACTIONS = {
  ADMIN_DATA_LOADING: "ADMIN_DATA_LOADING",
  SET_ADMIN_AUTH_TOKENS: "SET_ADMIN_AUTH_TOKENS",
  SET_ADMIN_USER_DATA: "SET_ADMIN_USER_DATA",
  ADMIN_LOGOUT: "ADMIN_LOGOUT",
  SET_ADMIN_ERROR: "SET_ADMIN_ERROR",
  CLEAR_ADMIN_ERRORS: "CLEAR_ADMIN_ERRORS",
  SET_ADMIN_MESSAGE: "SET_ADMIN_MESSAGE",
};

export default ADMIN_ACTIONS;